/*
 * KLOKI native cart opener — plnohodnotná náhrada za Qikify Slide Cart.
 *
 * Po přidání do košíku (jakékoli custom CTA přes /cart/add.js) refetchne obsah
 * nativního cart-draweru (Sense/Dawn) přes Cart Sections API a otevře ho.
 * Používá stejný mechanismus jako product-form.js (getSectionsToRender +
 * renderContents), jen refresh dělá přes cart_update_url (no-op update se
 * sections parametrem), takže funguje i pro CTA, které přidávají přímo fetchem.
 *
 * Volá se z: lp-grand-slam-offer, sticky ATC (normal+bundle), featured-collection,
 * main-product, kloki-care-upsell. Bez draweru na stránce → přesměrování na /cart.
 */
(function () {
  function drawer() {
    return document.querySelector('cart-drawer');
  }
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || '/cart';
  }
  // Třída is-empty na <cart-drawer> je serverová (stav při načtení stránky) a renderContents
  // ji NEODSTRAŇUJE — nativní product-form.js to dělá zvlášť ve svém finally. Bez toho zůstane
  // po přidání do košíku oblast s položkami skrytá CSSkem (bílá plocha) i s položkami v DOM.
  function syncEmptyClass(d, state) {
    if (!d || !state || typeof state.item_count !== 'number') return;
    if (state.item_count > 0) {
      d.classList.remove('is-empty');
    } else {
      d.classList.add('is-empty');
    }
  }

  function sectionIds() {
    var d = drawer();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender()
        .map(function (s) { return s.id; })
        .join(',');
    }
    return 'cart-drawer,cart-icon-bubble';
  }

  // Sdílená krátkodobá cache stavu košíku. Po přidání do košíku se na /cart.js ptalo
  // hned několik nezávislých míst (care upsell, auto-add-b, drawer) — naměřeno ~600 ms
  // sériově navíc. Volající do TTL sdílejí jeden request.
  var cartPromise = null;
  var cartAt = 0;
  function getCart(maxAgeMs) {
    var ttl = typeof maxAgeMs === 'number' ? maxAgeMs : 1500;
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    if (cartPromise && now - cartAt < ttl) return cartPromise;
    cartAt = now;
    cartPromise = fetch(cartUrl() + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .catch(function (e) { cartPromise = null; throw e; });
    return cartPromise;
  }
  // Jakákoli změna košíku cache zneplatní.
  function invalidateCart() { cartPromise = null; cartAt = 0; }

  // Otevře nativní drawer s čerstvým obsahem. Bez draweru → /cart.
  //
  // Sekce tahá GET přes Section Rendering API, NE POSTem na /cart/update.js:
  // POST je zápis do košíku a při souběhu s nativní změnou množství (/cart/change.js)
  // hrozí kolize, po které Dawn vypíše „Při aktualizaci košíku došlo k chybě".
  // GET je nemutující. Cestu bereme z location.pathname, ať zůstane kontext trhu/jazyka.
  function openCart() {
    var d = drawer();
    if (!d) {
      window.location = cartUrl();
      return;
    }
    var fallback = function () {
      try { d.open(); } catch (e) { window.location = cartUrl(); }
    };
    Promise.all([
      fetch(window.location.pathname + '?sections=' + sectionIds(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }),
      getCart(800)
    ])
      .then(function (res) {
        try {
          // Zastaralá chybová hláška z dřívějšího neúspěšného pokusu ať nezůstane viset.
          var errors = document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = '';
          syncEmptyClass(d, res[1]);
          d.renderContents({ sections: res[0] });
        } catch (e) {
          fallback();
        }
      })
      .catch(fallback);
  }

  // Pro volající, kteří /cart/add.js zavolali s parametrem sections a mají odpověď.
  function refreshAndOpen(response) {
    var d = drawer();
    if (d && response && response.sections) {
      try { syncEmptyClass(d, response); d.renderContents(response); return; } catch (e) {}
    }
    openCart();
  }

  window.KlokiCart = {
    open: openCart,
    refreshAndOpen: refreshAndOpen,
    drawer: drawer,
    getCart: getCart,
    invalidateCart: invalidateCart
  };

  // Bezpečnostní síť: jakékoli přežívající volání window.QikifyCart.open() (po vypnutí
  // Qikify už window.QikifyCart nedefinuje) se svede na nativní drawer.
  if (!window.QikifyCart) {
    window.QikifyCart = { open: openCart };
  }
})();
